export default "__VITE_ASSET__buYvANuV__"